import { PredefinedDataRow } from 'components/tables/data/predefined/types';
import P3Regular from 'components/typography/P3Regular';

/**
 * Column for the fault id.
 */
export default function PredefinedDataIdColumn({
  data: { globalPredefinedDataId, usersPredefinedDataId },
}: {
  data: PredefinedDataRow;
}) {
  return <P3Regular color="gray.8">{globalPredefinedDataId || usersPredefinedDataId}</P3Regular>;
}
